import React, { useMemo } from 'react';
import { eAdminAccountStatus, IAdminUserData } from '../../../../types/administration/userAdministration/IAdminUser';
import { CheckboxField } from '../../../../ui-toolkit';
import { useHasPermissions } from '../../../accessControl/hooks/useHasPermissions';
import { ePermissions } from '../../../../types/administration/userAdministration/ePermissions';
import { useListFeaturesQuery } from '../../../../API/administration/FeaturesAPI';
import { useListPagedAdminUsersQuery } from '../../../../API/administration/AdminUsersAPI';
import { createDefaultPageData } from '../../../../types/rest/IPageData';
import { SelectFieldTW } from '../../../../tailwindComponents/selectTW/SelectFieldTW';
import { SelectOption } from '../../../../tailwindComponents/selectTW/interfaces';
import { SimpleGrid } from '../../../../tailwindComponents/grid/SimpleGrid';

interface IFeatureUserFormFieldsProps {}

const defaultData = createDefaultPageData<IAdminUserData>();

export const FeatureUserFormFields: React.FC<IFeatureUserFormFieldsProps> = () => {
  const hasReadPermission = useHasPermissions([ePermissions.FeatureRead]);
  const { data: sortedGlobalFeatures = [] } = useListFeaturesQuery(undefined, { skip: !hasReadPermission });
  const { data: pagedAdminUserData = defaultData } = useListPagedAdminUsersQuery({
    status: eAdminAccountStatus.Active,
    fetchAll: true,
  });
  const featureOptions: SelectOption[] = useMemo(
    () =>
      sortedGlobalFeatures
        .filter((feature) => feature.isEditable) // Only show editable features
        .map((feature) => ({
          label: feature.name,
          value: feature.name,
        })),
    [sortedGlobalFeatures]
  );

  const userOptions: SelectOption[] = useMemo(
    () =>
      pagedAdminUserData.content.map((user) => ({
        label: user.fullName,
        value: user.id,
      })),
    [pagedAdminUserData]
  );

  return (
    <SimpleGrid>
      <SelectFieldTW name={'name'} options={featureOptions} labelText={'Feature'} placeholder={'Select'} />
      <SelectFieldTW name={'identityId'} options={userOptions} labelText={'User'} placeholder={'Select'} />
      <CheckboxField name={'isOn'} text={'Activate'} />
    </SimpleGrid>
  );
};
